import Swal from 'sweetalert2';

export const setupInterceptors = (apiInstance) => {

    console.log('Interceptor configurado para:', apiInstance.defaults.baseURL);

    apiInstance.interceptors.request.use(config => {
        const token = localStorage.getItem('token');

        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }

        return config;
    });

    apiInstance.interceptors.response.use(
        response => response,

        async (error) => {

            const status = error.response?.status;

            console.log('Erro capturado no interceptor:', status);

            // TOKEN EXPIRADO / INVÁLIDO
            if (status === 401) {

                await Swal.fire({
                    icon: "warning",
                    title: "Sessão expirada",
                    text: "Por favor, faça login novamente.",
                    confirmButtonText: "OK"
                });

                localStorage.removeItem('token');
                window.location.href = '/';

                return Promise.reject(error);
            }

            // SEM PERMISSÃO
            if (status === 403) {

                Swal.fire({
                    icon: "error",
                    title: "Acesso negado",
                    text: "Você não tem permissão para acessar este recurso."
                });

                return Promise.reject(error);
            }

            return Promise.reject(error);
        }
    );
};